import reducer from './fees.reducer';
import * as action from './fees.action';
import * as selector from './fees.selector';
import * as constant from './fees.constant';
import initialState from './fees.initialState';
import saga from './fees.saga';

export default {
  reducer,
  action,
  constant,
  selector,
  initialState,
  saga,
  name: constant.NAME,
};
